import { logger } from '@parrot-software/observability';

/** What `iam.enforcementMode` reports when the backend sent no mode at all. */
export const ABSENT_ENFORCEMENT_MODE = 'absent';

/**
 * Domain logger for the identity flows.
 *
 * Nothing logged here may carry a token of any kind, a complete email or a complete phone number.
 */
export const iamLog = logger.forDomain('IAM', { subdomain: 'authentication' });
